import * as React from "react";
import TodoList from "./TodoList";
import Counter from "./Counter";
import Benchmark from "./Benchmark";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

export default function App() {
  return (
    <Router>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://codesandbox.io/s/strange-antonelli-s8sbu"
      >
        Demo Source Code
      </a>
      <ul>
        <li>
          <Link to="/">TodoList</Link>
        </li>
        <li>
          <Link to="/counter">Counter</Link>
        </li>
        <li>
          <Link to="/benchmark">Benchmark</Link>
        </li>
      </ul>
      <Switch>
        <Route path="/benchmark">
          <h2>Benchmark</h2>
          <Benchmark />
        </Route>
        <Route path="/counter">
          <h2>Counter</h2>
          <Counter />
        </Route>
        <Route path="/">
          <h2>Todo List</h2>
          <TodoList />
        </Route>
      </Switch>
    </Router>
  );
}
